import { render, staticRenderFns } from "./IconSortAscendingOutline.vue?vue&type=template&id=ad07e70e"
import script from "./IconSortAscendingOutline.vue?vue&type=script&lang=js"
export * from "./IconSortAscendingOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports